import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Build artifact icon.
 *
 * A cube/box shape (flat isometric) with a horizontal line dividing
 * the top face from the bottom. Represents a build artifact/package.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Top face: cyan accent fill at 10%
 */
export const BuildIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Top face (parallelogram) with cyan accent fill */}
    <path
      d="M4 8 L12 4 L20 8 L12 12 Z"
      fill="#00d4ff"
      fillOpacity={0.1}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Left edge from top face down to bottom */}
    <path
      d="M4 8 L4 16 L12 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Right edge from top face down to bottom */}
    <path
      d="M20 8 L20 16 L12 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Horizontal divider line across the front face */}
    <path
      d="M4 12 L20 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

BuildIcon.displayName = "BuildIcon";

export default BuildIcon;
